import { endpoints } from './endpoints';
import { getAuthToken, request } from './http';

export interface SatCatalogEntry {
    clave: string;
    descripcion?: string;
    nombre?: string;
}

export interface SatUsoCfdi {
    clave: string;
    descripcion: string;
}

export interface SatPayType {
    key: string;
    label: string;
}

interface SatSearchBody {
    clave: string;
    compare?: string;
}

export const sat = {
    searchProductosServicios(body: SatSearchBody): Promise<SatCatalogEntry[]> {
        return request<SatCatalogEntry[]>(endpoints.sat.productosServicios(getAuthToken()), {
            method: 'POST',
            jsonBody: body,
        });
    },
    searchClaveUnidades(body: SatSearchBody): Promise<SatCatalogEntry[]> {
        return request<SatCatalogEntry[]>(endpoints.sat.claveUnidades(getAuthToken()), {
            method: 'POST',
            jsonBody: body,
        });
    },
    getUsoCfdi(): Promise<SatUsoCfdi[]> {
        return request<SatUsoCfdi[]>(endpoints.sat.usoCfdi(getAuthToken()));
    },
    getPayTypes(): Promise<SatPayType[]> {
        return request<SatPayType[]>(endpoints.sat.payTypes(getAuthToken()));
    },
};
